import { createAction } from '@reduxjs/toolkit';
import { asyncActionsCreator } from '../../global/redux';
import * as constants from './constants';

export const auth = asyncActionsCreator(constants.AUTH);
export const getValidationCode = asyncActionsCreator(
  constants.GET_VALIDATION_CODE
);
export const logout = createAction(constants.LOGOUT);
export const loginClearError = createAction(constants.LOGIN_CLEAR_ERROR);

export const getUserInfo = asyncActionsCreator(constants.GET_USER_INFO);
export const clearErrorMessage = createAction(constants.CLEAR_ERROR_MESSAGE);

export const getWhatsappAuthNumber = asyncActionsCreator(
  constants.GET_WHATSAPP_AUTH_NUMBER
);

export const telegramAuth = asyncActionsCreator(constants.TELEGRAM_AUTH);

export const getWarningMessage = asyncActionsCreator(
  constants.GET_WARNING_MESSAGE
);
